import { Controller as DarkMode } from "./Controller";
import { Controller as GrayScale } from "../gray-scale/Controller";

export default class DarkModeHandler {
  constructor() {
    this.thisHTML = document.querySelector('html');
    this.form = document.querySelector('#toggle-dark-mode');
    this.darkMode = new DarkMode();
    this.grayScale = new GrayScale();

    if (!this.form) {
      return;
    }
    
    this.trigger = this.form.querySelector('#enable-dark-mode');
    this.triggerSwitch = this.form.querySelector('.input-toggle-switch');

    if (this.trigger) {
      this.trigger.addEventListener('change', this.toggle.bind(this));
    } 
    if (this.triggerSwitch) {
      this.triggerSwitch.addEventListener('click', this.toggleSwitch.bind(this));
    }

    if (!this.darkMode.isModeDefined() && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      this.darkMode.enable();
      this.grayScale.disable();
    } else {
      this.checkLocalStorage();
    }

  }

  toggle(event) {

    event.preventDefault();

    if ( !this.thisHTML.getAttribute('data-theme') || this.thisHTML.getAttribute('data-theme') !== 'dark' ) {
      this.darkMode.enable(); 
      this.grayScale.disable();
    } else {
      this.darkMode.disable(); 
    }

    document.querySelector('#toggle-gray-scale .input-toggle-checkbox').classList.remove('is-checked');

  }

  toggleSwitch(event) {
    event.preventDefault();
    this.trigger.click();
  }

  checkLocalStorage() {
    const theme = localStorage.getItem('theme');

    if (theme === 'dark') {
      this.darkMode.enable();
      this.grayScale.disable();
    } else {
      this.darkMode.disable();
    }
  }

}